"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenQuestionTeacherPinSettingsSchema = exports.OpenQuestionPinSchema = exports.OpenQuestionPinLayoutTemplateSchema = exports.OpenQuestionPinSettingsSchema = exports.NUMBER_OF_IMAGES_ALLOWED = void 0;
const zod_1 = require("zod");
const pin_component_1 = require("../pin-component");
const layout_part_1 = require("../pin-component/layout-part");
const base_pin_1 = require("./base-pin");
const base_teacher_pin_1 = require("./base-teacher-pin");
const OpenQuestionPinLayoutKeySettingsSchema = zod_1.z.enum(['TITLE_ONLY', 'FIFTY_FIFTY']);
const LegacyOpenQuestionPinLayoutKeySettingsSchema = zod_1.z.enum([
    'LEGACY_TITLE_ONLY',
    'LEGACY_QUESTION_LEFT_WITH_IMAGE',
    'LEGACY_QUESTION_RIGHT_WITH_IMAGE',
    'LEGACY_IMAGE_ONLY',
    'LEGACY_EMPTY',
]);
const CombinedOpenQuestionKeySettingsSchema = zod_1.z.union([
    OpenQuestionPinLayoutKeySettingsSchema,
    LegacyOpenQuestionPinLayoutKeySettingsSchema,
]);
// TODO: Workaround number enum https://github.com/colinhacks/zod/issues/2686#issuecomment-1906248858
// Numbers are from v1, not defined for v2. Photo questions might be out of scope.
var NUMBER_OF_IMAGES_ALLOWED;
(function (NUMBER_OF_IMAGES_ALLOWED) {
    NUMBER_OF_IMAGES_ALLOWED[NUMBER_OF_IMAGES_ALLOWED["zero"] = 0] = "zero";
    NUMBER_OF_IMAGES_ALLOWED[NUMBER_OF_IMAGES_ALLOWED["one"] = 1] = "one";
    NUMBER_OF_IMAGES_ALLOWED[NUMBER_OF_IMAGES_ALLOWED["five"] = 5] = "five";
})(NUMBER_OF_IMAGES_ALLOWED || (exports.NUMBER_OF_IMAGES_ALLOWED = NUMBER_OF_IMAGES_ALLOWED = {}));
const OpenQuestionLayoutPartKeySchema = layout_part_1.LayoutPartSchema.extract(['TITLE', 'IMAGE1', 'ANSWER_AREA']);
exports.OpenQuestionPinSettingsSchema = base_pin_1.BaseInteractiveQuestionPinSettingsSchema.merge(zod_1.z.object({
    explanation: zod_1.z.string().nullable(),
    layout: CombinedOpenQuestionKeySettingsSchema,
    caseSensitive: zod_1.z.boolean(),
    diacriticSensitive: zod_1.z.boolean(),
    maximumNumberOfUploadsPerStudent: zod_1.z.nativeEnum(NUMBER_OF_IMAGES_ALLOWED),
    showStudentNames: zod_1.z.boolean(),
    layoutParts: zod_1.z.record(OpenQuestionLayoutPartKeySchema, zod_1.z.string().optional()),
}));
exports.OpenQuestionPinLayoutTemplateSchema = base_pin_1.BaseTemplateLayoutSchema.merge(zod_1.z.object({
    key: CombinedOpenQuestionKeySettingsSchema,
    layoutParts: zod_1.z.record(OpenQuestionLayoutPartKeySchema, pin_component_1.PinComponentSchema.optional()),
}));
exports.OpenQuestionPinSchema = base_pin_1.BasePinSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('OPEN_QUESTION'),
    settings: exports.OpenQuestionPinSettingsSchema,
}));
exports.OpenQuestionTeacherPinSettingsSchema = base_teacher_pin_1.BaseTeacherPinSettingsSchema.merge(zod_1.z.object({
    correctAnswers: zod_1.z.array(zod_1.z.string()).optional(),
}));
//# sourceMappingURL=open-question-pin.js.map